import { authApiService } from '@/api/authApiService';
import { PaymentDetailsGeneralType } from '@/types/paymentDetailsTypes';
import { ApiResponseType } from '@/types/sharedTypes';

export const getPaymentDetailsApi = (wireId: string): Promise<ApiResponseType<PaymentDetailsGeneralType>> => {
  const uri = `/organization/wires/${wireId}/payment-details/`;

  return authApiService.GET(uri);
};
